import BaseModelAPI from '../BaseModelAPI';

export default class StandarTimeCategory extends BaseModelAPI {
	static entity = 'standartimecategory';
	static entityName = 'standartimecategory';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}